import React from "react";
import { cn } from "@/lib/utils";
import { useTenant } from "@/context/TenantContext";

export function Logo({ className, size = 28 }) {
  const { tenant } = useTenant();
  const mark = (tenant?.logo_mark || tenant?.name?.[0] || "S").slice(0, 2);
  const displayName = tenant?.name || "Soubor One";
  return (
    <div className={cn("inline-flex items-center gap-2", className)}>
      {tenant?.logo_url ? (
        <img
          src={tenant.logo_url}
          alt={displayName}
          style={{ width: size, height: size }}
          className="object-contain shrink-0"
        />
      ) : (
        <div
          className="relative rounded-lg flex items-center justify-center text-white font-bold"
          style={{
            width: size, height: size,
            background: "linear-gradient(135deg, hsl(var(--primary)) 0%, hsl(var(--primary-hover)) 100%)",
            boxShadow: "0 4px 16px hsl(var(--primary) / 0.35), inset 0 1px 0 rgba(255,255,255,0.25)",
          }}
        >
          <span className="font-mono text-[13px] tracking-tighter">{mark}</span>
          <span className="absolute -right-1 -bottom-1 w-2 h-2 rounded-sm bg-white/90" />
        </div>
      )}
      <div className="font-bold tracking-tight text-[17px]">{displayName}</div>
    </div>
  );
}

export default Logo;
